module.exports = __webpack_public_path__ + "static/media/reference+form.2db55e7a.pdf";